import { ReactNode, RefObject, useEffect } from 'react';

import { setHeadings } from 'molecules/TableOfContents/store';

import { toKebabCase } from 'utils/strings';

const useArticleHeadings = (children: ReactNode, ref: RefObject<HTMLDivElement | null>) => {
  useEffect(() => {
    setTimeout(() => {
      const article = document.querySelector('article');
      const articleHeadings = article?.querySelectorAll('h2');

      if (!articleHeadings) {
        setHeadings([]);

        return;
      }

      const headings = Array.from(articleHeadings)
        .filter(heading => heading.textContent)
        .map(heading => {
          const text = heading.textContent as string;
          const id = toKebabCase(text);

          return {
            id,
            label: text,
            link: id,
          };
        });

      setHeadings(headings);
    }, 300);
  }, [children, ref.current]);
};

export default useArticleHeadings;
